/* eslint-disable no-undef */

// Función para formatear los precios
export const addPoints = (num: number) => {
  if (num == null) return "0";
  const parts = num.toString().split(".");
  // prettier-ignore
  parts[0] = parts[0].split("").reverse().join("").match(/.{1,3}/g)?.join(".").split("").reverse().join("") || "0";
  return parts[0];
};

// Test for addPoints function
if (typeof describe === "function") {
  describe("addPoints", () => {
    it("should format numbers with thousands separators", () => {
      expect(addPoints(1000)).toBe("1.000");
      expect(addPoints(1000000)).toBe("1.000.000");
      expect(addPoints(1234567)).toBe("1.234.567");
    });

    it("should handle numbers less than 1000", () => {
      expect(addPoints(999)).toBe("999");
      expect(addPoints(1)).toBe("1");
    });

    it("should handle edge cases for parts[0] logic", () => {
      expect(addPoints(0)).toBe("0");
      expect(addPoints(1000000000)).toBe("1.000.000.000");
      expect(addPoints(1234)).toBe("1.234");
    });
  });
}

// Función para capturar los decimales
export const getDecimals = (num: number) => {
  const decimals = num?.toFixed(2).split(".")[1];
  return decimals || "00";
};

// Tests for getDecimals function
if (typeof describe === "function") {
  describe("getDecimals", () => {
    it("should return two decimal places for numbers with decimals", () => {
      expect(getDecimals(10.25)).toBe("25");
      expect(getDecimals(3.14159)).toBe("14");
      expect(getDecimals(0.01)).toBe("01");
    });

    it("should return '00' for whole numbers", () => {
      expect(getDecimals(10)).toBe("00");
      expect(getDecimals(1000)).toBe("00");
    });

    it("should handle edge cases", () => {
      expect(getDecimals(0)).toBe("00");
      expect(getDecimals(0.1)).toBe("10");
      expect(getDecimals(0.001)).toBe("00");
    });

    it("should handle undefined and null", () => {
      expect(getDecimals(undefined as unknown as number)).toBe("00");
      expect(getDecimals(null as unknown as number)).toBe("00");
    });
  });
}

export const cambiarPuntoPorComas = (numero: number) => {
  if (numero == null) return "0,00";
  const [entero, decimal] = numero.toFixed(2).split(".");
  // prettier-ignore
  const priceWithPoints = entero.split("").reverse().reduce((acc, digit, index) => {
    if (index > 0 && index % 3 === 0) {
      return `${digit}.${acc}`;
    }
    return digit + acc;
  }, "");
  return `${priceWithPoints},${decimal}`;
};

// Tests for cambiarPuntoPorComas function
if (typeof describe === "function") {
  describe("cambiarPuntoPorComas", () => {
    it("should format numbers with thousands separators and comma for decimal", () => {
      expect(cambiarPuntoPorComas(1000)).toBe("1.000,00");
      expect(cambiarPuntoPorComas(1000000)).toBe("1.000.000,00");
      expect(cambiarPuntoPorComas(1234567.89)).toBe("1.234.567,89");
    });

    it("should handle numbers less than 1000", () => {
      expect(cambiarPuntoPorComas(999.99)).toBe("999,99");
      expect(cambiarPuntoPorComas(1)).toBe("1,00");
    });

    it("should handle numbers with more than two decimal places", () => {
      expect(cambiarPuntoPorComas(123.456)).toBe("123,46");
      expect(cambiarPuntoPorComas(0.12345)).toBe("0,12");
    });

    it("should handle edge cases", () => {
      expect(cambiarPuntoPorComas(0)).toBe("0,00");
      expect(cambiarPuntoPorComas(0.1)).toBe("0,10");
      expect(cambiarPuntoPorComas(1000000000.01)).toBe("1.000.000.000,01");
    });

    it("should handle null input", () => {
      expect(cambiarPuntoPorComas(null as unknown as number)).toBe("0,00");
    });
  });
}
